import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LogButton } from '@app/core/states/events-tracking.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { UiLoaderModule } from '@radioking/ui/loader';
import Player from '@vimeo/player';
import { PipesModule } from 'libs/shared/pipes/pipes.module';

interface DataIn {
  src: string;
  event?: string;
}
@Component({
  selector: 'rk-video-container',
  standalone: true,
  imports: [PipesModule, MatIconModule, UiLoaderModule],
  templateUrl: './video-container.component.html',
  styleUrl: './video-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoContainerComponent implements AfterViewInit {
  @Input()
  src: string;

  @Input()
  width = 450;
  @Input()
  height = 350;

  @Input()
  closeBtn = true;

  style: object = {};

  @Output()
  readonly close = new EventEmitter<void>();

  $portrait = signal(false);
  $playStarted = signal(false);

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataIn: DataIn,
    public readonly dialogRef: MatDialogRef<VideoContainerComponent>,
    private readonly elRef: ElementRef,
  ) {}

  ngAfterViewInit() {
    this.elRef.nativeElement.closest('.cdk-overlay-container').style['z-index'] = '3000';
    this.onResize();

    const player = new Player(document.querySelector('#ifrvimeo') as HTMLIFrameElement);
    player.on('loaded', () => {
      player.play();
    });

    player.on('play', () => {
      this.$playStarted.set(true);
    });
  }

  setProperties(props: object) {
    Object.assign(this, props);
  }

  onResize() {
    const ratio = window.innerWidth / window.innerHeight;
    this.$portrait.set(ratio < 16 / 9);
  }

  closeVideo() {
    if (this.dataIn.event) {
      this.logCloseClick();
    }
    this.dialogRef.close();
  }

  @Dispatch() logCloseClick = () =>
    new LogButton({
      name: this.dataIn.event,
    });
}
